import { Form } from "react-bootstrap";
import Style from "./FormPayment.module.scss";
import useFormPayment from "./useFormPayment";
import { useRtl } from "../../logic/useRtl";

const Formpayment = ({ userData, basicData, orderId }) => {
  let paymentOptionStatus = userData?.data?.payment_option;
  const { rtl } = useRtl({ Style });

  const isPayable = paymentOptionStatus == "1" || paymentOptionStatus == "2";

  const {
    containerId,
    ready,
    mountFailed,
    errorMsgCard,
    cardClick,
    t,
  } = useFormPayment({
    id: orderId,
    enabled: isPayable,
    isRenewal: paymentOptionStatus == 2,
  });

  return (
    <div
      className={`${Style.payment}  ${rtl}`}
      style={{ display: isPayable ? "" : "none" }}
    >
      {basicData?.data?.card_payment == "1" && (
        <div className={Style.checkbox}>
          <Form.Check
            type="radio"
            name="type"
            id="card"
            defaultChecked={true}
            label={""}
          />
          <div className={Style.check_label}>
            <div>
              <p>{t("cardType")}</p>
              <span>{t("cardPay")}</span>
            </div>
          </div>
        </div>
      )}
      {/* A single mount point for the aggregate Flow component, which renders
          every payment method the session declares along with its own method
          picker — nothing is filtered client-side. It sits outside
          .payment_input because that is a space-between flex row built for the
          old side-by-side Frames fields, which squeezed the mount point. No
          global `loading` class either — it is the button spinner from
          common.scss and sets pointer-events:none, which would deaden Flow's
          iframes. */}
      <div
        className={`${Style.methods} ${
          ready || mountFailed ? "" : Style.methods_loading
        }`}
        style={{ display: !cardClick ? "none" : "" }}
      >
        {/* Shimmer placeholder for the gap between the session request and
            Flow's onReady. It overlays the mount point rather than replacing
            it: the container must stay laid out or Flow measures zero. */}
        {!ready && !mountFailed && (
          <div className={Style.skeleton} aria-hidden="true">
            <div className={Style.skeleton_head}>
              <span className={`${Style.shimmer} ${Style.skeleton_radio}`} />
              <span className={`${Style.shimmer} ${Style.skeleton_title}`} />
            </div>
            <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
            <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
            <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
            <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
            <div className={Style.skeleton_row}>
              <div className={Style.skeleton_col}>
                <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
                <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
              </div>
              <div className={Style.skeleton_col}>
                <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
                <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
              </div>
            </div>
            <span className={`${Style.shimmer} ${Style.skeleton_button}`} />
          </div>
        )}
        {/* Must stay in the DOM and laid out from the first render: Flow
            measures the element on mount and renders wrong if it is hidden. */}
        <div id={containerId} />
      </div>
      <small className={`error`}>
        {errorMsgCard && <span>{errorMsgCard}</span>}
      </small>
    </div>
  );
};

export default Formpayment;
